import { render, staticRenderFns } from "./ArtworkDetail.vue?vue&type=template&id=5c80e029&scoped=true"
import script from "./ArtworkDetail.vue?vue&type=script&lang=js"
export * from "./ArtworkDetail.vue?vue&type=script&lang=js"
import style0 from "./ArtworkDetail.vue?vue&type=style&index=0&id=5c80e029&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c80e029",
  null
  
)

export default component.exports